import { CALL_INTAKE_V2_API } from 'middleware/intakeV2Api';
import {
  GET_ACTIVITY_LOG_AUTHORIZATION_ALL_FAILURE,
  GET_ACTIVITY_LOG_AUTHORIZATION_ALL_REQUEST,
  GET_ACTIVITY_LOG_AUTHORIZATION_ALL_SUCCESS,
  GET_ACTIVITY_LOG_AUTHORIZATION_FILE_FAILURE,
  GET_ACTIVITY_LOG_AUTHORIZATION_FILE_REQUEST,
  GET_ACTIVITY_LOG_AUTHORIZATION_FILE_SUCCESS,
  GET_ACTIVITY_LOG_CLIENT_FAILURE,
  GET_ACTIVITY_LOG_CLIENT_REQUEST,
  GET_ACTIVITY_LOG_CLIENT_SUCCESS,
  GET_ACTIVITY_LOG_EXPENSE_FAILURE,
  GET_ACTIVITY_LOG_EXPENSE_REQUEST,
  GET_ACTIVITY_LOG_EXPENSE_SUCCESS,
  GET_ACTIVITY_LOG_RECURRING_PAYABLE_FAILURE,
  GET_ACTIVITY_LOG_RECURRING_PAYABLE_REQUEST,
  GET_ACTIVITY_LOG_RECURRING_PAYABLE_SUCCESS,
  GET_ACTIVITY_LOG_SURVEY_CONFIGURATION_FAILURE,
  GET_ACTIVITY_LOG_SURVEY_CONFIGURATION_REQUEST,
  GET_ACTIVITY_LOG_SURVEY_CONFIGURATION_SUCCESS,
  GET_ACTIVITY_LOG_TEMPLATE_CONFIGURATION_FAILURE,
  GET_ACTIVITY_LOG_TEMPLATE_CONFIGURATION_REQUEST,
  GET_ACTIVITY_LOG_TEMPLATE_CONFIGURATION_SUCCESS,
  GET_ACTIVITY_LOG_VENDOR_FAILURE,
  GET_ACTIVITY_LOG_VENDOR_REQUEST,
  GET_ACTIVITY_LOG_VENDOR_SUCCESS,
  GET_ACTIVITY_LOG_VOUCHER_FAILURE,
  GET_ACTIVITY_LOG_VOUCHER_REQUEST,
  GET_ACTIVITY_LOG_VOUCHER_SUCCESS
} from './activityLog.types';

export const REACT_APP_INTAKE_API_V2_URL = process.env.REACT_APP_INTAKE_API_V2_URL || 'https://api-reloinsight-v2-test.trcgm.com/';

export const getAuthorizationFileLogs = fileId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        GET_ACTIVITY_LOG_AUTHORIZATION_FILE_REQUEST,
        GET_ACTIVITY_LOG_AUTHORIZATION_FILE_SUCCESS,
        GET_ACTIVITY_LOG_AUTHORIZATION_FILE_FAILURE
      ],
      authenticated: true,
      endpoint: `api/logs/authorizations/${fileId}`,
      method: 'GET'
    }
  };
};

export const getAuthorizationAllFileLogs = fileId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        GET_ACTIVITY_LOG_AUTHORIZATION_ALL_REQUEST,
        GET_ACTIVITY_LOG_AUTHORIZATION_ALL_SUCCESS,
        GET_ACTIVITY_LOG_AUTHORIZATION_ALL_FAILURE
      ],
      authenticated: true,
      endpoint: `api/logs/authorizations/${fileId}/all`,
      method: 'GET'
    }
  };
};

export const getExpenseLogs = expenseId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_ACTIVITY_LOG_EXPENSE_REQUEST, GET_ACTIVITY_LOG_EXPENSE_SUCCESS, GET_ACTIVITY_LOG_EXPENSE_FAILURE],
      authenticated: true,
      endpoint: `api/logs/expenses/${expenseId}`,
      method: 'GET'
    }
  };
};

export const getVoucherLogs = voucherId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_ACTIVITY_LOG_VOUCHER_REQUEST, GET_ACTIVITY_LOG_VOUCHER_SUCCESS, GET_ACTIVITY_LOG_VOUCHER_FAILURE],
      authenticated: true,
      endpoint: `api/logs/vouchers/${voucherId}`,
      method: 'GET'
    }
  };
};

export const getRecurringPayableLogs = recurringPayableId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        GET_ACTIVITY_LOG_RECURRING_PAYABLE_REQUEST,
        GET_ACTIVITY_LOG_RECURRING_PAYABLE_SUCCESS,
        GET_ACTIVITY_LOG_RECURRING_PAYABLE_FAILURE
      ],
      authenticated: true,
      endpoint: `api/logs/recurringPayables/${recurringPayableId}`,
      method: 'GET'
    }
  };
};

export const getSurveyLogs = surveyId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        GET_ACTIVITY_LOG_SURVEY_CONFIGURATION_REQUEST,
        GET_ACTIVITY_LOG_SURVEY_CONFIGURATION_SUCCESS,
        GET_ACTIVITY_LOG_SURVEY_CONFIGURATION_FAILURE
      ],
      authenticated: true,
      endpoint: `api/logs/surveys/${surveyId}`,
      method: 'GET'
    }
  };
};

export const getClientLogs = clientId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_ACTIVITY_LOG_CLIENT_REQUEST, GET_ACTIVITY_LOG_CLIENT_SUCCESS, GET_ACTIVITY_LOG_CLIENT_FAILURE],
      authenticated: true,
      endpoint: `api/logs/clients/${clientId}`,
      method: 'GET'
    }
  };
};

export const getTemplateLogs = templateId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        GET_ACTIVITY_LOG_TEMPLATE_CONFIGURATION_REQUEST,
        GET_ACTIVITY_LOG_TEMPLATE_CONFIGURATION_SUCCESS,
        GET_ACTIVITY_LOG_TEMPLATE_CONFIGURATION_FAILURE
      ],
      authenticated: true,
      endpoint: `api/logs/templates/${templateId}`,
      method: 'GET'
    }
  };
};

export const getVendorLogs = vendorId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_ACTIVITY_LOG_VENDOR_REQUEST, GET_ACTIVITY_LOG_VENDOR_SUCCESS, GET_ACTIVITY_LOG_VENDOR_FAILURE],
      authenticated: true,
      endpoint: `api/logs/vendors/${vendorId}`,
      method: 'GET'
    }
  };
};
